import {InjectionToken} from "@angular/core";

export const POPOVER_HOST_OVERRIDE = new InjectionToken("popover host override");

export interface IPopoverHostOverride {
  getHost(): Element;
}

